import { DataView } from "@/components/organisms/DataView";
import { useConnectionSetup } from "@/hooks/useConnectionSetup";
import { Objects } from "@/objects";
import { State } from "@/state";

export function JournalEntriesView() {
  const dataViewMode = State(
    (store) => store.dataViewModes[store.activeAppView] ?? "table",
  );

  const {
    columns,
    rows,
    loading,
    totalCount,
    deleteNodeButtonProps,
    loadNext,
    networkStatus,
  } = useConnectionSetup({ appView: "journal-entries" });

  return (
    <DataView
      totalCount={totalCount}
      columns={columns}
      rows={rows}
      loadNext={loadNext}
      isLoading={loading}
      networkStatus={networkStatus}
      onCheckedRowsButtonsProps={[deleteNodeButtonProps]}
      viewMode={dataViewMode}
      onAddNew={() =>
        State.getState().pushToCommandStack({
          commandDefinitionId: "create-JournalEntryObject",
        })
      }
      placeholderRow={Objects.JournalEntryObject.placeholder}
      emptyState={{
        ReactIcon: Objects.JournalEntryObject.ReactIcon,
        title: "No journal entries yet",
        description:
          "Entries posted against your chart of accounts show up here, whether written by hand or by a rule.",
        actionLabel: "New journal entry",
      }}
    />
  );
}
